import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_AUDIT_TRAILS_LIST_REQUEST = 'FETCH_AUDIT_TRAILS_LIST_REQUEST';
export const FETCH_AUDIT_TRAILS_LIST_SUCCESS = 'FETCH_AUDIT_TRAILS_LIST_SUCCESS';
export const FETCH_AUDIT_TRAILS_LIST_FAILURE = 'FETCH_AUDIT_TRAILS_LIST_FAILURE';

export const FETCH_RULE_JOB_AUDIT_LIST_REQUEST = 'FETCH_RULE_JOB_AUDIT_LIST_REQUEST';
export const FETCH_RULE_JOB_AUDIT_LIST_SUCCESS = 'FETCH_RULE_JOB_AUDIT_LIST_SUCCESS';
export const FETCH_RULE_JOB_AUDIT_LIST_FAILURE = 'FETCH_RULE_JOB_AUDIT_LIST_FAILURE';

export const DOWNLOAD_AUDIT_CSV_REQUEST = 'DOWNLOAD_AUDIT_CSV_REQUEST';
export const DOWNLOAD_AUDIT_CSV_SUCCESS = 'DOWNLOAD_AUDIT_CSV_SUCCESS';
export const DOWNLOAD_AUDIT_CSV_FAILURE = 'DOWNLOAD_AUDIT_CSV_FAILURE';

export const fetchAuditTrailsList = (params: IFetchAuditTrailsParams) => ({
  [CALL_API]: {
    endpoint: 'agencies/audit-trails',
    method: 'get',
    params,
    authenticated: true,
    types: [FETCH_AUDIT_TRAILS_LIST_REQUEST, FETCH_AUDIT_TRAILS_LIST_SUCCESS, FETCH_AUDIT_TRAILS_LIST_FAILURE],
  },
});

export const fetchRuleJobAuditList = (params: IFetchAuditTrailsParams) => ({
  [CALL_API]: {
    endpoint: 'agencies/rule-job-audit',
    method: 'get',
    params,
    authenticated: true,
    types: [FETCH_RULE_JOB_AUDIT_LIST_REQUEST, FETCH_RULE_JOB_AUDIT_LIST_SUCCESS, FETCH_RULE_JOB_AUDIT_LIST_FAILURE],
  },
});

export const downloadAuditCSV = (params: IRuleExecutionHistoryDownloadParams) => ({
  [CALL_API]: {
    endpoint: 'agencies/rule-job-audit/download',
    method: 'get',
    params,
    authenticated: true,
    types: [DOWNLOAD_AUDIT_CSV_REQUEST, DOWNLOAD_AUDIT_CSV_SUCCESS, DOWNLOAD_AUDIT_CSV_FAILURE],
  },
});
